import { render, staticRenderFns } from "./VincularCamposAdicionais.vue?vue&type=template&id=7b1ae7f5&scoped=true"
import script from "./VincularCamposAdicionais.vue?vue&type=script&lang=js"
export * from "./VincularCamposAdicionais.vue?vue&type=script&lang=js"
import style0 from "./VincularCamposAdicionais.vue?vue&type=style&index=0&id=7b1ae7f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ae7f5",
  null
  
)

export default component.exports